import { render, staticRenderFns } from "./ViewAllAdvances.vue?vue&type=template&id=35078db8&scoped=true&"
import script from "./ViewAllAdvances.vue?vue&type=script&lang=js&"
export * from "./ViewAllAdvances.vue?vue&type=script&lang=js&"
import style0 from "./ViewAllAdvances.vue?vue&type=style&index=0&id=35078db8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35078db8",
  null
  
)

component.options.__file = "ViewAllAdvances.vue"
export default component.exports